import {resolveGoogExport} from 'dgetz/tsclj'

export function filenameToSrc(filename) {
  const filenameToSrc = resolveGoogExport('ladder.ux.image.filename__GT_src');
  return filenameToSrc(filename)
}

export default {filenameToSrc};
